import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=2cc923bc&scoped=true&"
import script from "./breadcrumb.js?vue&type=script&lang=js&"
export * from "./breadcrumb.js?vue&type=script&lang=js&"
import style0 from "./breadcrumb.scss?vue&type=style&index=0&id=2cc923bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc923bc",
  null
  
)

export default component.exports